import { render, staticRenderFns } from "./CustomPopupImage.vue?vue&type=template&id=66942760&scoped=true"
import script from "./CustomPopupImage.vue?vue&type=script&lang=js"
export * from "./CustomPopupImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66942760",
  null
  
)

export default component.exports